export const Items: import('../../../sim/dex-items').ModdedItemDataTable = {
	altarianite: {
		inherit: true,
		isNonstandard: "Future",
	},
	audinite: {
		inherit: true,
		isNonstandard: "Future",
	},
	beedrillite: {
		inherit: true,
		isNonstandard: "Future",
	},
	blueorb: {
		inherit: true,
		isNonstandard: "Future",
	},
	cameruptite: {
		inherit: true,
		isNonstandard: "Future",
	},
	custapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	diancite: {
		inherit: true,
		isNonstandard: "Future",
	},
	galladite: {
		inherit: true,
		isNonstandard: "Future",
	},
	glalitite: {
		inherit: true,
		isNonstandard: "Future",
	},
	jabocaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	latiasite: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	latiosite: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	lopunnite: {
		inherit: true,
		isNonstandard: "Future",
	},
	metagrossite: {
		inherit: true,
		isNonstandard: "Future",
	},
	micleberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	pidgeotite: {
		inherit: true,
		isNonstandard: "Future",
	},
	redorb: {
		inherit: true,
		isNonstandard: "Future",
	},
	rowapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	sablenite: {
		inherit: true,
		isNonstandard: "Future",
	},
	salamencite: {
		inherit: true,
		isNonstandard: "Future",
	},
	sceptilite: {
		inherit: true,
		isNonstandard: "Future",
	},
	sharpedonite: {
		inherit: true,
		isNonstandard: "Future",
	},
	slowbronite: {
		inherit: true,
		isNonstandard: "Future",
	},
	steelixite: {
		inherit: true,
		isNonstandard: "Future",
	},
	swampertite: {
		inherit: true,
		isNonstandard: "Future",
	},
};
